module.exports = __webpack_public_path__ + "img/twitter.09e22ec5.svg";